import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { isImportedPulserSurvey } from '../../lib/helpers';
import { DashboardSection } from './DashboardSection';
import { CompletedDashboardSurveyCard } from './SurveyCards';
import { DashboardSurvey } from './utils';

type CompletedSurveysProps = {
  surveys?: DashboardSurvey[];
  onResultsClick: () => void;
};

export const CompletedSurveys: FC<CompletedSurveysProps> = ({ surveys, onResultsClick }) => {
  const { t } = useTranslation('dashboard');

  if (!surveys?.length) {
    return null;
  }

  return (
    <DashboardSection
      key={'completedSurveys'}
      title={t('completedSurveys')}
      keyName={'completed-surveys'}
      buttons={<div />}
    >
      {surveys.map((survey) => (
        <CompletedDashboardSurveyCard
          key={survey.id}
          survey={survey}
          onResultsClick={onResultsClick}
          hideDetail={isImportedPulserSurvey(survey)}
        />
      ))}
    </DashboardSection>
  );
};
